var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("nav", { staticClass: "navbar", class: _vm.classes }, [
    _c("div", { class: _vm.containerClasses }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.closeMenu,
              expression: "closeMenu",
            },
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show,
              expression: "show",
            },
          ],
          staticClass: "navbar-collapse navbar-custom-collapse collapse show",
          class: _vm.menuClasses,
        },
        [_vm._t("default", null, { closeMenu: _vm.closeMenu })],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }